import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';

import { AppUiModule } from '../ui/app-ui.module';

import { BreadcrumbsModule } from './breadcrumbs/breadcrumbs.module';
import { TopbarComponent } from './topbar/topbar.component';
import { FooterComponent } from './footer/footer.component';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { StepsComponent } from './steps/steps.component';
import { StepComponent } from './steps/step.component';
import { StepsErrorsComponent } from './steps/steps-errors.component';
import { ConfirmModalComponent } from './modals/confirm-modal/confirm-modal.component';
import { PipesModule } from './pipes/pipes.module';
import { TableSortingModule } from './sortable-column/sortable-column.module';
import { RoleAccessModule } from './role-access/role-access.module';
import { UserPopoverComponent } from './popovers/user-popover/user-popover.component';
import { BrigadePopoverComponent } from './popovers/brigade-popover/brigade-popover.component';
import { TopbarNotificationsComponent } from './topbar-notifications/topbar-notifications.component';
import { TopbarNotificationsPopoverComponent } from './topbar-notifications/popovers/topbar-notifications-popover/topbar-notifications-popover.component';
import { CallbackComponent } from './callback/callback.component';
import { TopbarNavigationComponent } from './topbar-navigation/topbar-navigation.component';
import { WayMovementComponent } from './way-movement/way-movement.component';
import { PaginationComponent } from './pagination/pagination.component';
import { SearchPopoverComponent } from './popovers/search-popover/search-popover.component';
import { FormsModule } from '@angular/forms';

@NgModule({
    declarations: [
        TopbarComponent,
        FooterComponent,
        BreadcrumbsComponent,
        StepsComponent,
        StepComponent,
        StepsErrorsComponent,
        ConfirmModalComponent,
        UserPopoverComponent,
        BrigadePopoverComponent,
        TopbarNotificationsComponent,
        TopbarNotificationsPopoverComponent,
        CallbackComponent,
        TopbarNavigationComponent,
        WayMovementComponent,
        PaginationComponent,
        SearchPopoverComponent,
    ],
    imports: [CommonModule, RouterModule, FormsModule, NgxMaskDirective, NgxMaskPipe, AppUiModule, BreadcrumbsModule, PipesModule, TableSortingModule, RoleAccessModule],
    exports: [
        TopbarComponent,
        FooterComponent,
        BreadcrumbsComponent,
        BreadcrumbsModule,
        StepsComponent,
        StepComponent,
        StepsErrorsComponent,
        ConfirmModalComponent,
        UserPopoverComponent,
        BrigadePopoverComponent,
        PipesModule,
        TableSortingModule,
        RoleAccessModule,
        TopbarNotificationsComponent,
        CallbackComponent,
        WayMovementComponent,
        PaginationComponent,
        NgxMaskDirective,
        NgxMaskPipe,
        SearchPopoverComponent,
    ],
    providers: [provideNgxMask()],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule {}
